/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { AfterContentInit, booleanAttribute, Component, ContentChildren, Input, OnDestroy, QueryList } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { Subscription } from 'rxjs';
import { CardColComponent } from '../card-col/card-col.component';
import { CardItemComponent } from '../card-item/card-item.component';

@Component({
  selector: 'ods-card',
  template: `<ng-content />`,
  host: {
    class: '@container flex flex-col bg-whitetext rounded-md ring ring-gray-300 divide-y divide-gray-300 empty:hidden',
    '[attr.role]': 'list ? "list" : "region"',
    '[attr.aria-labelledby]': 'list ? null : colHeadingId',
  },
})
export class CardComponent implements AfterContentInit, OnDestroy {
  @Input({ transform: booleanAttribute }) list: boolean = false;

  @ContentChildren(CardItemComponent) cardItems!: QueryList<CardItemComponent>;

  subscription: Subscription;
  public colHeadingId: string;

  ngAfterContentInit(): void {
    this.initializeCardItemsWithTimeout();
    this.subscription = this.cardItems.changes.subscribe(() => this.initializeCardItemsWithTimeout());
  }

  initializeCardItemsWithTimeout(): void {
    setTimeout(() => this.initializeCardItems());
  }

  initializeCardItems(): void {
    if (this.list) this.initializeListCardItems();
    else this.initializeSingleCardItem();
  }

  initializeListCardItems(): void {
    this.cardItems.forEach((item: CardItemComponent) => this.setIsListItemForItem(item));
  }

  initializeSingleCardItem(): void {
    this.colHeadingId = uniqueId('card-col-heading-');
    this.getFirstColumnOfCard().headingId = this.colHeadingId;
  }

  setIsListItemForItem(item: CardItemComponent): void {
    item.isListItem = true;
  }

  getFirstColumnOfCard(): CardColComponent {
    return this.cardItems.get(0).cardCols.get(0);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
